import { MessageCircle } from "lucide-react";

export default function StickyContact() {
  return (
    <a
      href="https://wa.me/12089019386?text=Hi%20Coach%20Manny%2C%20I%27d%20like%20to%20learn%20more%20about%20your%20training."
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="sticky-whatsapp"
      className="fixed bottom-6 left-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform"
    >
      <MessageCircle size={22} />
    </a>
  );
}
